import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';

import { doCreateUserWithEmailAndPassword } from '../../firebase/auth';
import { doCreateUser} from '../../firebase/db'
import * as routes from '../../constants/routes';

const SignUpPage = ({ history }) =>
  <div>
    <h1>Registrierung</h1>
        <SignUpForm history={history} />
  </div>

const INITIAL_STATE = {
    username: '',
    email: '',
    passwordOne: '',
    passwordTwo: '',
    error: null,
  }

  const byPropKey = (propertyName, value) => () => ({
    [propertyName]: value,
  });
  

class SignUpForm extends Component {
  constructor(props) {
    super(props);
    this.state = { ...INITIAL_STATE };
  }

  onSubmit = (event) => {
    const {
      username,
      email,
      passwordOne,
    } = this.state;

    
    const role='canidate'
      doCreateUserWithEmailAndPassword(email, passwordOne)
      .then(authUser => {
        const email = authUser.user.email
        const uid = authUser.user.uid
        const userName = username
    
        doCreateUser(uid, userName, email,role)
      // uid, username, email, role
        // Create a user in your own accessible Firebase Database too
       /*
        db.doCreateUser(authUser.user.uid, username, email)
          .then(() => {
            auth.doUpdateUserProfile(username, role)
            this.setState(() => ({ ...INITIAL_STATE }));
            history.push(routes.HOME);
          }) 
          */
          
            
          
          .catch(error => {
            this.setState(byPropKey(' erster error', error));
          });

      })
      .catch(error => {
        this.setState(byPropKey('zweiter error', error));
      });

    event.preventDefault();
  }

    render() {
        const {
            username,
            email,
            passwordOne,
            passwordTwo,
            error,
        } = this.state;
        const isInvalid =
            passwordOne !== passwordTwo ||
            passwordOne === '' ||
            email === '' ||
            username === '';

        return (
        <form onSubmit={this.onSubmit}>
            <input
            value={username}
            onChange={event => this.setState(byPropKey('username', event.target.value))}
            type="text"
            placeholder="Full Name"
            />
            <input
            value={email}
            onChange={event => this.setState(byPropKey('email', event.target.value))}
            type="text"
            placeholder="Email Address"
            />
            <input
            value={passwordOne}
            onChange={event => this.setState(byPropKey('passwordOne', event.target.value))}
            type="password"
            placeholder="Password"
            />
            <input
            value={passwordTwo}
            onChange={event => this.setState(byPropKey('passwordTwo', event.target.value))}
            type="password"
            placeholder="Confirm Password"
            />
            <button disabled={isInvalid} type="submit">
                Sign Up
            </button>

            { error && <p>{error.message}</p> }

        </form>
        );
    }
}

const SignUpLink = () =>
  <p>
    Sie haben noch keine Account?
    {' '}
    <Link to={routes.SIGN_UP}>Registrieren</Link>
  </p>

export default withRouter(SignUpPage);

export {
  SignUpForm,
  SignUpLink,
};


// WEBPACK FOOTER //
// ./src/Components/UserAuth/SignUp.js